import find from 'lodash/find';
import { IsEnum, Matches } from 'class-validator';

import analytics from '@ad-scripts/lib/analytics';
import createCollectionResource from 'src/actions/shared/createResource';
import { matchesError } from 'src/models/DomainError';
import * as sharedTypes from 'src/actions/shared/sharedTypes';
import { UpdateOptions } from 'src/actions/shared/createResource';

export enum AgentStatusType {
  Away = 'AWAY',
  Active = 'ACTIVE',
}

class AgentStatusReason {
  id: string;
  disabled: boolean;
  @IsEnum(AgentStatusType, { message: 'Please select a type' })
  type: AgentStatusType;
  default: boolean;

  @Matches(/\S/, { message: 'Enter a status name' })
  name: string;
}

const agentStatusReasonsResource = createCollectionResource<AgentStatusReason>({
  name: 'agentStatusReasons',
  endpoint: 'v1/orgs/:orgId/agent-status-reasons/:id',
  type: AgentStatusReason,
  observerCreator: ({ actions }) => {
    return ({ dispatch }) => {
      return {
        onBroadcast(item) {
          dispatch(actions.broadcast(item));
        },
      };
    };
  },
  options: {
    getErrorMessage: error => {
      if (matchesError(error, { attr: 'name', code: 'taken' })) {
        return 'A status with the same name already exists';
      }
    },
    patchOnUpdate: true,
    toastMessages: {
      onAdd: agentStatusReason => `Added "${agentStatusReason.name}"`,
      onUpdate: agentStatusReason => `Updated status to "${agentStatusReason.name}"`,
    },
  },
});

const { update } = agentStatusReasonsResource.effects;

const augmentedUpdate: sharedTypes.AppThunk =
  (params: any, attrs: any, opts?: UpdateOptions) => async (dispatch, getState) => {
    const reason = find(getState().agentStatusReasons.values, reason => reason.id === params.id);
    if (reason && !reason.disabled && attrs.disabled) {
      analytics.track('Agent Status Reason Archived');
    }
    dispatch(update(params, attrs, opts));
  };
agentStatusReasonsResource.effects.update = augmentedUpdate;

export default agentStatusReasonsResource;
